import React, { useState, Fragment, useEffect } from "react";
import Modal from "react-modal";
import CalendlyButton from "./calendlyButton";
import { Listbox, Transition } from "@headlessui/react";
import { useDispatch, useSelector } from "react-redux";
import Cookie from "js-cookie";
import rocket from "../assets/images/rocket.gif";
import {
  CheckIcon,
  SelectorIcon,
  ExclamationCircleIcon,
} from "@heroicons/react/solid";
import { createChiliDemo, sendChiliToZap } from "../Redux/actions/userActions";
import OptimisedImage from "./optimisedImage";
import Iframe from "react-iframe";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const employeeRanges = [
  { id: 0, range: "Select a Staff Count" },
  {
    id: 1,
    range: "0-19",
  },
  { id: 20, range: "20-49" },
  { id: 50, range: "50-99" },
  { id: 100, range: "100-499" },
  { id: 500, range: "500-999" },
  { id: 1000, range: "1000-2499" },
  { id: 2500, range: "2,500-4,999" },
  { id: 5000, range: "5,000-9,999" },
  { id: 10000, range: "10,000-24,999" },
  { id: 25000, range: "25,000 +" },
];

const Chillipiperbtn = ({ country, pricing }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selected, setSelected] = useState(employeeRanges[0]);
  const [alertMsg, setAlertMsg] = useState("");
  const [lessThan20, setLessThan20] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    company: "",
    staffCount: "",
  });

  const dispatch = useDispatch();

  const chilipiperDetails = useSelector((state) => state.chilipiperdemo);
  const { loading, success, error, chiliData } = chilipiperDetails;

  const validateEmail = (input) => {
    const re =
      // eslint-disable-next-line
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(input);
  };

  const { firstName, lastName, email, phone, company, staffCount } = formData;

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!firstName || !lastName || !email || !phone || !company) {
      setAlertMsg("Please fill in all inputs.");
    } else if (!validateEmail(email)) {
      setAlertMsg("Please enter a valid email.");
    } else if (phone.length !== 10) {
      setAlertMsg(
        "Please enter your 10 digit phone number. No spaces or dashes."
      );
    } else if (staffCount === "Select a Staff Count" || !staffCount) {
      setAlertMsg("Please select a staff count.");
    } else {
      setAlertMsg("");
      if (staffCount !== "0-19") {
        // if staff count is greater than 20, book a demo
        // Clearbit GTM Data Layer push for clearbit identify call
        let dataLayer = window.dataLayer;
        dataLayer = window.dataLayer || [];
        dataLayer.push({
          var: "chilipiper",
          event: "chilipiper_submit",
          email,
          company,
        });
        dispatch(
          createChiliDemo({
            form: {
              FirstName: firstName,
              LastName: lastName,
              Email: email,
              Phone: phone,
              Company: company,
              Employee_Range__c: staffCount,
              utm_source__c: Cookie.get("utm_source")
                ? Cookie.get("utm_source")
                : Cookie.get("utm_source_util"),
              utm_medium__c: Cookie.get("utm_medium")
                ? Cookie.get("utm_medium")
                : Cookie.get("utm_medium_util"),
              utm_campaign__c: Cookie.get("utm_campaign_util")
                ? Cookie.get("utm_campaign_util")
                : "Chilipiper_Demo_Booking",
              Signup_Type__c: "Online Demo Booking",
              Lead_Country_New__c: "United States",
              GCLID__c: "",
              utm_content__c: "Chilipiper Button",
              utm_term__c: "Book a Call",
            },
            options: {
              router: "US_Marketing_Booking",
              debug: false,
              map: false,
              webHook:
                "https://webhook.site/d0eadad5-426a-49ef-aba8-ebd0092cd854",
              locale: "en_US",
            },
          })
        );
      } else {
        setLessThan20(true);
        sendChiliToZap({
          firstName,
          lastName,
          email,
          company,
          phone,
          staffCount,
          utmMedium: Cookie.get("utm_medium")
            ? Cookie.get("utm_medium")
            : Cookie.get("utm_medium_util"),
          utmSource: Cookie.get("utm_source")
            ? Cookie.get("utm_source")
            : Cookie.get("utm_source_util"),
          utmCampaign: Cookie.get("utm_campaign_util")
            ? Cookie.get("utm_campaign_util")
            : "Chilipiper_Demo_Booking",
          utmTerm: "Book a Call",
          utmContent: "Chilipiper Button",
          pageURL: Cookie.get("track_lead_page_util"),
          date: Date.now(),
        });
      }
    }
  };

  useEffect(() => {
    setFormData({ ...formData, staffCount: selected.range });
    // eslint-disable-next-line
  }, [selected, success, error, chiliData, loading]);

  return (
    <>
      {/* If on pricing page, make btn display block */}
      {pricing ? (
        <button
          id="chili1"
          className="mt-8 block w-full btn btn__solid btn__orange text-center"
          onClick={() => setModalOpen(true)}
        >
          Contact Sales
        </button>
      ) : (
        <>
          {country === "uk" ? (
            <CalendlyButton country={country} />
          ) : (
            <button
              id="chili2"
              className="btn btn__solid btn__orange mt-6 mx-auto rounded hover:cursor-pointer mr-4"
              onClick={() => setModalOpen(true)}
            >
              Book a Call
            </button>
          )}
        </>
      )}
      <Modal
        ariaHideApp={false}
        isOpen={modalOpen}
        onRequestClose={() => setModalOpen(false)}
        className="modal__content px-2 lg:px-10 py-20 relative"
        overlayClassName="modal__overlay"
        contentLabel="Redirect Notice"
      >
        {loading && (
          <OptimisedImage className="mx-auto" src={rocket} alt="rocket" />
        )}
        {error && (
          <>
            <h4 className="m-0 p-0 text-blue-legacy">
              Network Error: We are sorry for the inconvenience.
            </h4>
            <h6 className="m-0 p-0 mt-4 text-blue-legacy">
              Please click the button for our backup system. Thank you!
            </h6>
            <a
              href="https://workforce.na.chilipiper.com/router/us_marketing_booking?utm_source=workforce&utm_medium=direct&utm_campaign=network_error_chiliform&utm_content=backup_button&utm_term=book_a_call"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="btn btn__solid btn__orange mt-8 block mx-auto">
                Book a Call!
              </button>
            </a>
          </>
        )}
        {success && (
          <Iframe
            url={chiliData.url}
            width="350px"
            height="700px"
            className="myClassname"
            display="initial"
            position="relative"
          />
        )}
        {lessThan20 && (
          <>
            <h4 className="p-0 text-blue-dark">{`Hey ${firstName}, thank you for taking the time to fill out our Book a Call form.`}</h4>
            <p className="text-blue-dark">
              In order to make the best use of your time and ours, we kindly
              suggest you download our mobile app.
            </p>
            <p className="text-blue-dark mt-4">
              Our mobile app is best suited for companies smaller than 20
              employees. We have an amazing product tour in app! Checkout our
              app{" "}
              <span className="text-blue-legacy">
                <a
                  href="https://workforce.onelink.me/YhCn/b1500462"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  here
                </a>
              </span>{" "}
              or scan the QR code to download.{" "}
            </p>
            <OptimisedImage
              className="mx-auto block w-32 mt-8"
              src="images/new_timeclock_qr_code.png"
              alt="qr_code"
            />
          </>
        )}
        {!error && !loading && !success && !lessThan20 && (
          <Fragment>
            <button onClick={() => setModalOpen(false)}>
              <i
                className="material-icons absolute ppacity-50"
                style={{ top: ".75rem", right: ".55rem" }}
              >
                close
              </i>
            </button>

            <div className="grid grid-cols-2 gap-4 px-8">
              <img
                src="/images/WF-colored.svg"
                alt="workforce"
                className="col-span-2 mx-auto h-10 w-full mb-4"
              />
              <div className="col-span-2 sm:col-span-1 ">
                <label
                  htmlFor="firstName"
                  className="block text-sm font-medium text-gray-700"
                >
                  First Name
                </label>
                <div >
                  <input
                    type="text"
                    name="firstName"
                    onChange={(e) => onChange(e)}
                    id="firstName"
                    className="shadow-sm focus:ring-blue-legacy focus:border-blue-legacy block w-full sm:text-sm border-gray-300 border rounded-md "
                    placeholder="First"
                  />
                </div>
              </div>
              <div className="col-span-2 sm:col-span-1 ">
                <label
                  htmlFor="lastName"
                  className="block text-sm font-medium text-gray-700"
                >
                  Last Name
                </label>
                <div className="mt-1">
                  <input
                    type="text"
                    name="lastName"
                    onChange={(e) => onChange(e)}
                    id="lastName"
                    className="shadow-sm focus:ring-blue-legacy focus:border-blue-legacy block w-full sm:text-sm border-gray-300 border rounded-md"
                    placeholder="Last"
                  />
                </div>
              </div>
               <div className="col-span-2 sm:col-span-1 -mt-6">
                <label
                  htmlFor="company"
                  className="block text-sm font-medium text-gray-700"
                >
                  Company Name
                </label>
                <div className="mt-1">
                  <input
                    type="text"
                    name="company"
                    onChange={(e) => onChange(e)}
                    id="company"
                    className="shadow-sm focus:ring-blue-legacy focus:border-blue-legacy block w-full sm:text-sm border-gray-300 border rounded-md"
                    placeholder="Business LLC."
                  />
                </div>
              </div>
              <div className="col-span-2 sm:col-span-1 mb-20 sm:mb-0 -mt-6 ">
                <Listbox value={selected} onChange={setSelected}>
                  {({ open }) => (
                    <>
                      <Listbox.Label className="block text-sm font-medium text-gray-700 ">
                        Staff Count
                      </Listbox.Label>
                      <div className="absolute">
                        <Listbox.Button className="bg-white relative w-full border border-gray-200 shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1  focus:border-blue-legacy  sm:text-sm " style={{borderRadius: ".25rem"}}>
                          <span
                            className={
                              selected.id === 0
                                ? "block truncate text-gray-400"
                                : "block truncate"
                            }
                          >
                            {selected.range}
                          </span>
                          <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                            <SelectorIcon
                              className="h-5 w-5 text-gray-300"
                              aria-hidden="true"
                            />
                          </span>
                        </Listbox.Button>

                        <Transition
                          show={open}
                          as={Fragment}
                          leave="transition ease-in duration-100"
                          leaveFrom="opacity-100"
                          leaveTo="opacity-0"
                        >
                          <Listbox.Options
                            static
                            className="relative z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-gray-300 ring-opacity-5 overflow-auto focus:outline-none sm:text-sm"
                          >
                            {employeeRanges.map((empRange) => (
                              <Listbox.Option
                                key={empRange.id}
                                className={({ active }) =>
                                  classNames(
                                    active
                                      ? "text-white bg-blue-legacy"
                                      : "text-gray-900",
                                    "cursor-default select-none relative py-2 pl-3 pr-9"
                                  )
                                }
                                value={empRange}
                              >
                                {({ selected, active }) => (
                                  <>
                                    <span
                                      className={classNames(
                                        selected
                                          ? "font-semibold text-blue-legacy"
                                          : "font-normal",
                                        "block truncate"
                                      )}
                                    >
                                      {empRange.range}
                                    </span>

                                    {selected ? (
                                      <span
                                        className={classNames(
                                          active
                                            ? "text-white"
                                            : "text-blue-legacy",
                                          "absolute inset-y-0 right-0 flex items-center pr-4"
                                        )}
                                      >
                                        <CheckIcon
                                          className="h-5 w-5"
                                          aria-hidden="true"
                                        />
                                      </span>
                                    ) : null}
                                  </>
                                )}
                              </Listbox.Option>
                            ))}
                          </Listbox.Options>
                        </Transition>
                      </div>
                    </>
                  )}
                </Listbox>
              </div>
              
              <div className="col-span-2 sm:col-span-1 -mt-6">
                <label
                  htmlFor="phone"
                  className="block text-sm font-medium text-gray-700"
                >
                  Phone
                </label>
                <div className="mt-1 relative rounded-md shadow-sm">
                  <input
                    type="text"
                    name="phone"
                    onChange={(e) => onChange(e)}
                    id="phone"
                    className="focus:ring-blue-legacy focus:border-blue-legacy border block w-full pl-16 sm:text-sm border-gray-300 rounded-md"
                    placeholder="555-987-6543"
                  />
                </div>
              </div>
              <div></div>
              <div className="col-span-2 sm:col-span-1 -mt-6">
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700"
                >
                  Email
                </label>
                <div className="mt-1">
                  <input
                    type="email"
                    name="email"
                    onChange={(e) => onChange(e)}
                    id="email"
                    className="shadow-sm focus:ring-blue-legacy focus:border-blue-legacy block w-full sm:text-sm border-gray-300 border rounded-md "
                    placeholder="name@company.com"
                  />
                </div>
              </div>
              <div></div>
              
             
             
              {alertMsg && (
                <small className="text-red col-span-2">
                  {" "}
                  <ExclamationCircleIcon
                    className="h-5 w-5 text-red-500 inline-block -mt-1"
                    aria-hidden="true"
                  />
                  {alertMsg}
                </small>
              )}
              <button
                onClick={(e) => handleSubmit(e)}
                // onClick={(e) => handleSubmit(e)}
                className="btn btn__solid btn__blue col-span-2"
              >
                Book a Call
              </button>
            </div>
          </Fragment>
        )}
      </Modal>
    </>
  );
};

export default Chillipiperbtn;
